module.exports = __webpack_public_path__ + "img/dashboard.ff1af03a.svg";